import { t } from 'i18next';

export function getSubTitleNameField(index: number) {
  return `sub-title-${index}`;
}

export function getSubTitleTranslateKey(index: number) {
  return t(`excel-sub-title`, { level: index });
}
